<template>
  <section>
  <div class="t-headline10 mgt-50 pdt-6 mgb-16 font-m t-color-headline-black">{{ $t('30067') }}</div>
  <div class="mdc-card mgb-24">

    <div class="mgl-24 mgr-24">
      <div v-if="completionData" class="mgt-24">
        <div class="t-headline7 font-m mgb-12">
          {{ $t('30069') }}
        </div>
        <div class="d-flex align-items-center justify-content-between pdt-16 pdb-16">
          <div class="d-flex align-items-center">
            <i class="material-icons mgr-6 t-color-iconInactive font-22 mgr-32">assignment</i>
            <div class="t-body1 t-color-bodyGrayA font-r l-spacing45 t-line-1"> {{ $t('30070') }} </div>
          </div>
          <div class="d-flex align-items-center">
            <div class="t-body1 t-color-headlineBlack font-r l-spacing45 min-w-80 t-right">{{ $t('30073', {str: completionData.minRate}) }}</div>
          </div>
        </div>

        <div v-if="completionData && completionData.examScoreType" class="d-flex align-items-center justify-content-between pdt-16 pdb-16 ">
          <div class="d-flex align-items-center">
            <i class="material-icons mgr-6 t-color-iconInactive font-22 mgr-32">note_alt</i>
            <div class="t-body1 t-color-bodyGrayA font-r l-spacing45 t-line-1"> {{ $t('30071') }} </div>
          </div>
          <div class="d-flex align-items-center">
            <div class="t-body1 t-color-headlineBlack font-r l-spacing45 min-w-80 t-right"> {{ $t(completionData.examScoreType && completionData.examScoreType.translate) }} {{ $t('30074', {str: completionData.examScore}) }}</div>
          </div>
        </div>

        <div v-if="completionData && completionData.homeworkScore" class="d-flex align-items-center justify-content-between pdt-16 pdb-16 ">
          <div class="d-flex align-items-center">
            <i class="material-icons-outlined mgr-6 t-color-iconInactive font-22 mgr-32">lightbulb</i>
            <div class="t-body1 t-color-bodyGrayA font-r l-spacing45 t-line-1"> {{ $t('30114') }} </div>
          </div>
          <div class="d-flex align-items-center">
            <div class="t-body1 t-color-headlineBlack font-r l-spacing45 min-w-80 t-right"> {{ $t(completionData.homeworkScoreType && completionData.homeworkScoreType.translate) }} {{ $t('30074', {str: completionData.homeworkScore}) }}</div>
          </div>
        </div>

        <div v-if="completionData && completionData.askCount" class="d-flex align-items-center justify-content-between pdt-16 pdb-16 ">
          <div class="d-flex align-items-center">
            <i class="material-icons mgr-6 t-color-iconInactive font-22 mgr-32">account_box</i>
            <div class="t-body1 t-color-bodyGrayA font-r l-spacing45 t-line-1"> {{ $t('30072') }} </div>
          </div>
          <div class="d-flex align-items-center">
            <div class="t-body1 t-color-headlineBlack font-r l-spacing45 min-w-80 t-right">{{$t('30075', {str: completionData.askCount})}}</div>
          </div>
        </div>
        <div class="divider mgt-16 mgx--24"></div>
      </div>


      <div v-if="pointData" class="d-flex align-items-center justify-content-between mgt-24 mgb-24">
        <div class="t-headline7 font-m">
          {{ $t('30076') }}
        </div>
        <div class="t-body1 pdl-24 font-r">
          {{ $t('30077', {str: $n(pointData.earnPoint)}) }}
        </div>
      </div>

      <div v-if="certificateSet && certificateSet.length > 0">
      <div class="divider mgt-16 mgx--24"></div>
      <div class=" mgt-24 mgb-8" tabindex="0">
        <div class="t-headline7 font-m">
          {{ $t('30068') }}
        </div>
        
        <div v-for="(cert, index) in certificateSet" :key="index">
          <div class="pdt-16 pdb-16  pdr-24 d-flex align-items-center">
            <div class="mgr-20">
              <img alt="icon52" src="../../../images/my-certificate-icon.svg">
            </div>
            <div>
              <div class="t-body1 t-color-headlineBlack font-r"> {{ cert.name }} </div>
              <div class="t-body2 t-color-headlineBlack font-r mgt-6"> {{ cert.params.ISSUE_ORGANIZATION_NAME }} </div>
            </div>
          </div>
        </div>
        
      </div>
      <div class="divider mgx--24"></div>
      </div>
    </div>

    <div v-if="badgesData && badgesData.length > 0" class="mgt-24 mgl-24 mgr-24 mgb-8">
      <div class="t-headline7 font-m mgb-12">
        {{ $t('30078') }}
      </div>
      <div v-for="(badge, index) in badgesData" :key="index" class="d-flex align-items-center justify-content-between pdt-16 pdb-16">
        <div class="d-flex align-items-center justify-content-center">
          <img v-if="badge.image" :src="badge.image" alt="" class="icon52 mgr-20">
          <i v-else class="material-icons-outlined mgr-6 t-color-iconInactive font-22 mgr-32">help_center</i>
          <div class="t-body1 t-color-headlineBlack font-r l-spacing45 t-line-1"> {{ badge.name }} </div>
        </div>
      </div>
    </div>

    </div>
  </section>
</template>

<script>
import microDegreeApi from "@/api/microDegreeApi";

export default {
  name: "Certificate",

  props: ['certificateSet'],

  data() {
    return {
      completionData: null,
      pointData: null,
      badgesData: null
    }
  },

  mounted() {
    this.fetchData();
  },

  methods: {
    fetchData() {
      let params = this.setParams();

      microDegreeApi.guestLearnOnlineViewCompletion(params).then((response) => {
        this.completionData = response.data.data;
      }).catch((err) => {})

      microDegreeApi.guestLearnOnlineViewPoint(params).then((response) => {
        this.pointData = response.data.data;
      }).catch((err) => {})

      microDegreeApi.guestLearnOnlineViewBadges(params).then((response) => {
        this.badgesData = response.data.data;
      }).catch((err) => {})
    },

    setParams() {
      const params = {
        degreeId: this.$route.params.degreeId
      }
      return params;
    }
  }
}
</script>

<style scoped>
.mgx--24{
  margin-left: -24px;
  margin-right: -24px;
}
</style>
